// src/components/DonationModal.jsx
// Mostra dopo la pubblicazione di un evento, opzionale e non invasivo

import React from 'react';

export default function DonationModal({ onClose, message }) {
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 9999,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '16px'
        }}>
            <div style={{
                background: 'white', borderRadius: '16px',
                padding: '32px 24px', maxWidth: '360px', width: '100%',
                textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
            }}>
                {/* Icona */}
                <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎉</div>

                {/* Titolo */}
                <h2 style={{ margin: '0 0 8px 0', fontSize: '20px', color: '#2e7d32' }}>
                    {message || 'Evento pubblicato!'}
                </h2>

                {/* Messaggio donazione */}
                <p style={{ margin: '0 0 24px 0', fontSize: '14px', color: '#666', lineHeight: '1.5' }}>
                    Se questo servizio ti è utile e vuoi aiutarci a mantenerlo gratuito per tutti, puoi sostenere la piattaforma con una donazione libera.
                </p>

                {/* Bottoni donazione */}
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '20px', flexWrap: 'wrap' }}>
                    <a
                        href="https://www.paypal.com/paypalme/Giuliani434"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                            padding: '12px 20px', background: '#0070ba', color: 'white',
                            textDecoration: 'none', borderRadius: '8px',
                            fontSize: '14px', fontWeight: '700',
                            boxShadow: '0 2px 8px rgba(0,112,186,0.4)'
                        }}
                    >
                        ☕ PayPal
                    </a>

                    <a
                        href="https://donate.stripe.com/4gM5kCbmceIvanaeBq5kk00"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                            padding: '12px 20px', background: '#635bff', color: 'white',
                            textDecoration: 'none', borderRadius: '8px',
                            fontSize: '14px', fontWeight: '700',
                            boxShadow: '0 2px 8px rgba(99,91,255,0.4)'
                        }}
                    >
                        ☕ Stripe
                    </a>
                </div>

                {/* Link "Salta" */}
                <button
                    onClick={onClose}
                    style={{
                        background: 'none', border: 'none',
                        color: '#999', fontSize: '13px',
                        cursor: 'pointer', textDecoration: 'underline', padding: '4px'
                    }}
                >
                    No grazie, continua →
                </button>
            </div>
        </div>
    );
}
